import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

export interface LienMail {
  id: string;
  label: string;
  url: string;
}
export interface EnvoiMailPayload {
  objet: string;
  contenu: string;
  liens: { label: string; url: string }[];
  nomCertificat: string;
  certificatId: string;   // AJOUT
  apprenants: { lastname: string; firstname: string; email: string; certificat: string }[];
}

export interface EnvoiMailFormPayload {
  objet: string;
  contenu: string;
  liens: { label: string; url: string }[];
}

export interface ResultatEnvoiMail {
  succes: boolean;
  message: string;
}

@Component({
  selector: 'app-envoi-mail-modal',
  templateUrl: './envoi-mail-modal.component.html',
  styleUrls: ['./envoi-mail-modal.component.css'],
})
export class EnvoiMailModalComponent implements OnChanges {
  @Input() visible = false;
  @Input() nombreDestinataires = 0;
  @Input() envoiEnCours = false;
  @Input() resultatEnvoi: ResultatEnvoiMail | null = null;
  @Output() fermer = new EventEmitter<void>();
  @Output() envoyer = new EventEmitter<EnvoiMailFormPayload>();
  @Output() fermerResultat = new EventEmitter<void>();

  objet = '';
  contenu = '';
  liens: LienMail[] = [];

  formulaireSoumis = false;
  etape: 'edition' | 'recapitulatif' = 'edition';
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && !changes['visible'].currentValue) {
      this.reinitialiserFormulaire();
    }
  }

  private genererId(): string {
    return Math.random().toString(36).slice(2, 10);
  }

  ajouterLien(): void {
    this.liens = [...this.liens, { id: this.genererId(), label: '', url: '' }];
  }

  supprimerLien(id: string): void {
    this.liens = this.liens.filter((l) => l.id !== id);
  }

  private lienEstIncomplet(l: LienMail): boolean {
    return !!(l.label.trim() || l.url.trim()) && !(l.label.trim() && l.url.trim());
  }

  get liensInvalides(): boolean {
    return this.liens.some((l) => this.lienEstIncomplet(l));
  }

  get formulaireValide(): boolean {
    return this.objet.trim().length > 0 && this.contenu.trim().length > 0 && !this.liensInvalides;
  }

  soumettre(): void {
    this.formulaireSoumis = true;
    if (!this.formulaireValide || this.envoiEnCours) {
      return;

    }
    this.etape = 'recapitulatif';
    // const payload: EnvoiMailFormPayload = {
    //   objet: this.objet.trim(),
    //   contenu: this.contenu,
    //   liens: this.liens
    //     .filter((l) => l.label.trim() && l.url.trim())
    //     .map((l) => ({ label: l.label.trim(), url: l.url.trim() }))
    // };

    // this.envoyer.emit(payload);
  }

  modifier(): void {
    if (this.envoiEnCours) {
      return;
    }
    this.etape = 'edition';
  }

  confirmerEnvoi(): void {
    if (this.envoiEnCours) {
      return;
    }

    const payload: EnvoiMailFormPayload = {
      objet: this.objet.trim(),
      contenu: this.contenu,
      liens: this.liensValides.map((l) => ({ label: l.label.trim(), url: l.url.trim() })),
    };

    this.envoyer.emit(payload);
  }

  onFermerConfirmation(): void {
    const succes = this.resultatEnvoi?.succes ?? false;
    this.fermerResultat.emit();

    if (succes) {
      this.reinitialiserFormulaire();
      this.fermer.emit();
    }
  }

  fermerModal(): void {
    if (this.envoiEnCours) {
      return;
    }
    this.reinitialiserFormulaire();
    this.fermer.emit();
  }

  private reinitialiserFormulaire(): void {
    this.objet = '';
    this.contenu = '';
    this.liens = [];
    this.formulaireSoumis = false;
    this.etape = 'edition'; // NOUVEAU
  }

  get liensValides(): LienMail[] {
    return this.liens.filter((l) => l.label.trim() && l.url.trim());
  }
}